import { createActions } from 'redux-actions'

export const constants = {
  SUBMIT_LESSON_FORM: 'SUBMIT_LESSON_FORM',
  FETCH_LESSON_LIST: 'FETCH_LESSON_LIST',
  DELETE_LESSON: 'DELETE_LESSON',
  UPDATE_LESSON: 'UPDATE_LESSON',
  FETCH_LESSON: 'FETCH_LESSON',
  UPDATE_LESSON_FORM_FIELD: 'UPDATE_LESSON_FORM_FIELD',
  RESET_LESSON_FORM_FIELDS: 'RESET_LESSON_FORM_FIELDS',
  ADD_QUESTION: 'ADD_QUESTION',
  REMOVE_QUESTION: 'REMOVE_QUESTION',
  UPDATE_QUESTION: 'UPDATE_QUESTION',
  UPDATE_QUESTION_DESCRIPTION: 'UPDATE_QUESTION_DESCRIPTION',
  ADD_ANSWER: 'ADD_ANSWER',
  REMOVE_ANSWER: 'REMOVE_ANSWER',
  UPDATE_ANSWER: 'UPDATE_ANSWER',
  UPDATE_ANSWER_DESCRIPTION: 'UPDATE_ANSWER_DESCRIPTION',
  UPDATE_ANSWER_CORRECT: 'UPDATE_ANSWER_CORRECT',
  FETCH_LESSON_RESPONSE: 'FETCH_LESSON_RESPONSE',
  UPDATE_LESSON_RESPONSE: 'UPDATE_LESSON_RESPONSE',
  LESSON_RESPONSE_COMPLETED: 'LESSON_RESPONSE_COMPLETED',
  UPDATE_QUESTION_TYPE: 'UPDATE_QUESTION_TYPE'
}

export const actions = createActions({
  RESET_LESSON_FORM_FIELDS: (showMessage = true) => ({ showMessage }),
  SUBMIT_LESSON_FORM: {
    REQUEST: ({ form }) => ({ form }),
    SUCCESS: success => success,
    FAILURE: error => error
  },
  FETCH_LESSON_LIST: {
    REQUEST: () => ({}),
    SUCCESS: success => success,
    FAILURE: error => error
  },
  DELETE_LESSON: {
    REQUEST: ({ id }) => ({ id }),
    SUCCESS: success => success,
    FAILURE: error => error
  },
  UPDATE_LESSON: {
    REQUEST: ({ lesson }) => ({ lesson }),
    SUCCESS: success => success,
    FAILURE: error => error
  },
  FETCH_LESSON: {
    REQUEST: ({ id }) => ({ id }),
    SUCCESS: success => success,
    FAILURE: error => error
  },
  ADD_QUESTION: {
    REQUEST: () => ({}),
  },
  REMOVE_QUESTION: {
    REQUEST: ({ index }) => ({ index }),
  },
  UPDATE_QUESTION: {
    REQUEST: ({ index, text }) => ({ index, text }),
  },
  ADD_ANSWER: {
    REQUEST: ({ question_index }) => ({ question_index }),
  },
  REMOVE_ANSWER: {
    REQUEST: ({ question_index, index }) => ({ question_index, index }),
  },
  UPDATE_ANSWER: {
    REQUEST: ({ question_index, index, text }) => ({ question_index, index, text }),
  },
  FETCH_LESSON_RESPONSE: {
    REQUEST: ({ id, call_taker_id }) => ({ id, call_taker_id }),
    SUCCESS: success => success,
    FAILURE: error => error
  },
  UPDATE_LESSON_RESPONSE: {
    REQUEST: ({ id, call_taker_id, question_index, index }) => ({ id, call_taker_id, question_index, index }),
    SUCCESS: success => success,
    FAILURE: error => error
  },
  LESSON_RESPONSE_COMPLETED: {
    REQUEST: ({ id, completed }) => ({ id, completed }),
    SUCCESS: success => success,
    FAILURE: error => error
  },
})